import React, { Component } from 'react'
import clsx from 'clsx';
import { withStyles } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import CardMedia from '@material-ui/core/CardMedia';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import { CircleToBlockLoading } from 'react-loadingg';
import WatchLaterIcon from '@material-ui/icons/WatchLater';
import TimelineIcon from '@material-ui/icons/Timeline';
import { deepOrange } from '@material-ui/core/colors';
import ReportIcon from '@material-ui/icons/Report';
import ContractorPlanning from '../ContractorPlanning/ContractorPlanning';
import JobPlan from '../JobPlan/JobPlan';
import PlanningTool from '../PlanningTool/PlanningTool';
import PreConstructionForm from '../PreConstructionForm/preconstructionform';
import GanttChart from '../GanttChart/GanttChart';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import AllocationCentres from '../AllocationCentres/AllocationCentres';
import PersonIcon from '@material-ui/icons/Person';
import Tooltip from '@material-ui/core/Tooltip';
import ListAltIcon from '@material-ui/icons/ListAlt';
import Report from '../Report/Report';

const drawerWidth = 295;

const useStyles = (theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9) + 1,
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        width: `calc(100% - ${drawerWidth}px)`,
        padding: theme.spacing(3),
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    orange: {
        color: theme.palette.getContrastText(deepOrange[500]),
        backgroundColor: deepOrange[500],
        width: theme.spacing(4),
        height: theme.spacing(4),
    },
});

const bbColorTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#005D99',
        },
        secondary: {
            main: '#0091B5',
        },
    }
})

const gniUser = localStorage.getItem("bb_gni_user");

class Home extends Component {

    constructor(props) {
        super(props)
        this.state = {
            openDrawer: false,
            isLoading: true,
            viewClass: 'home',
            sameClassChange: false,
        }
    }

    componentDidMount() {
        if (!gniUser) {
            window.location.href = "/";
        }
        else {
            this.setState({ isLoading: false });
        }
    }

    render() {
        const { classes } = this.props;
        const handleDrawerOpen = () => { this.setState({ openDrawer: true }) };
        const handleDrawerClose = () => { this.setState({ openDrawer: false }) };
        const handleViewChange = (e, val) => {
            this.setState({ sameClassChange: true });
            if (val === "Sign Out") {
                localStorage.removeItem("bb_gni_user");
                window.location.href = "/";
            } else {
                this.setState({ viewClass: val });
            }
            setTimeout(() => { this.setState({ sameClassChange: false }); }, 100);
        };
        return (
            <ThemeProvider theme={bbColorTheme}>
                {(this.state.isLoading) ? (
                    <CircleToBlockLoading color='#005D99' />
                ) :
                    (
                        <div className={classes.root}>
                            <CssBaseline />
                            <AppBar position="fixed" className={clsx(classes.appBar, { [classes.appBarShift]: this.state.openDrawer })}>
                                <Toolbar>
                                    <IconButton color="inherit" aria-label="open drawer" onClick={handleDrawerOpen} edge="start" className={clsx(classes.menuButton, { [classes.hide]: this.state.openDrawer, })}>
                                        <MenuIcon />
                                    </IconButton>
                                    <Typography variant="h6" noWrap className={classes.title}>
                                        Contractor Planning
                                    </Typography>
                                </Toolbar>
                            </AppBar>
                            <Drawer variant="permanent" className={clsx(classes.drawer, { [classes.drawerOpen]: this.state.openDrawer, [classes.drawerClose]: !this.state.openDrawer, })} classes={{ paper: clsx({ [classes.drawerOpen]: this.state.openDrawer, [classes.drawerClose]: !this.state.openDrawer, }), }} >
                                <div className={classes.toolbar}>
                                    <CardMedia component="img" alt="Balfour Beatty" image={process.env.PUBLIC_URL + '/bb.png'} title="Balfour Beatty" style={{ width: '190px' }} />
                                    <IconButton onClick={handleDrawerClose}>
                                        <ChevronLeftIcon />
                                    </IconButton>
                                </div>
                                <Divider />
                                <List>
                                    {['Contractor Planning', 'Job Plan & Crew', 'Planning Tool', 'Gantt Chart', 'Reinstating Agent Centres', 'Reinstating Crew Centres', 'Reinstating Crew Report', 'Pre-Construction Form Report'].map((text, index) => (
                                        <Tooltip title={text} key={index}>
                                            <ListItem button key={text} onClick={e => handleViewChange(e, text)}>
                                                <ListItemIcon>
                                                    {
                                                        index === 0 ? <InboxIcon /> :
                                                            index === 1 ? <WatchLaterIcon /> :
                                                                index === 2 ? <ReportIcon /> :
                                                                    index === 3 ? <TimelineIcon /> :
                                                                        index === 4 ? <PersonIcon /> :
                                                                            index === 5 ? <PersonIcon /> :
                                                                                index === 6 ? <ListAltIcon /> :
                                                                                    index === 7 ? <ListAltIcon /> :
                                                                                        <InboxIcon />
                                                    }
                                                </ListItemIcon>
                                                <ListItemText primary={text} />
                                            </ListItem>
                                        </Tooltip>
                                    ))}
                                </List>
                                {
                                    <List>
                                        {['Sign Out'].map((text, index) => (
                                            <Tooltip title="Sign Out" key={index}>
                                                <ListItem button key={text} onClick={e => handleViewChange(e, text)}>
                                                    <ListItemIcon>{index % 2 === 0
                                                        ? <ExitToAppIcon />
                                                        : <ExitToAppIcon />}
                                                    </ListItemIcon>
                                                    <ListItemText primary={text} />
                                                </ListItem>
                                            </Tooltip>
                                        ))}
                                    </List>
                                }
                                <Divider />
                            </Drawer>
                            <main className={classes.content}>
                                <div className={classes.toolbar} />
                                {
                                    (!this.state.isLoading) ? (
                                        (this.state.viewClass === 'home') ? (<ContractorPlanning />) :
                                            (this.state.viewClass === 'Contractor Planning') ? (<ContractorPlanning />) :
                                                (this.state.viewClass === 'Job Plan & Crew') ? (<JobPlan />) :
                                                    (this.state.viewClass === 'Planning Tool') ? (<PlanningTool />) :
                                                        (this.state.viewClass === 'Gantt Chart') ? (<GanttChart />) :
                                                            (this.state.viewClass === 'Pre-Con Form') ? (<PreConstructionForm />) :
                                                                (this.state.viewClass === 'Reinstating Agent Centres') ? ((!this.state.sameClassChange) ? (<AllocationCentres type="ReinstatingAgent" />) : (null)) :
                                                                    (this.state.viewClass === 'Reinstating Crew Centres') ? ((!this.state.sameClassChange) ? (<AllocationCentres type="ReinstatingCrew" />) : (null)) :
                                                                        (this.state.viewClass === 'Reinstating Crew Report') ? ((!this.state.sameClassChange) ? (<Report type="Reinstating Crew Report" />) : (null)) :
                                                                            (this.state.viewClass === 'Pre-Construction Form Report') ? ((!this.state.sameClassChange) ? (<Report type="Pre-Construction Form Report" />) : (null))
                                                                                : (null)
                                    ) : (null)
                                }
                            </main>
                        </div>
                    )
                }
            </ThemeProvider>
        )
    }
}
export default withStyles(useStyles)(withSnackbar(Home));